import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AppSidebarComponent } from '../sidebar/app.sidebar.component';
import { Subscription } from 'rxjs';
import { FileService } from 'src/app/common/services/file/file.service';
import { AuthService } from 'src/app/common/services/auth/auth.service';
import { OrganizationService } from 'src/app/common/services/organization/organization.service';

@Component({
  selector: 'app-topbar',
  styles: [
    `
      .premium-bg {
        background: linear-gradient(
          to top,
          rgba(213, 173, 109, 1) 0%,
          rgba(213, 173, 109, 1) 26%,
          rgba(226, 186, 120, 1) 35%,
          rgba(163, 126, 67, 1) 45%,
          rgba(145, 112, 59, 1) 61%,
          rgba(213, 173, 109, 1) 100%
        );
        border: 0px;
      }
    `
  ],
  templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent implements OnInit {
  @ViewChild('menubutton') menuButton!: ElementRef;
  @ViewChild('searchinput') searchInput!: ElementRef;
  @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;
  searchActive = false;
  subscriptions = new Subscription();
  profilePicture: any;
  currentOrganizationName = '';
  isPremiumOrg = false;

  constructor(
    public layoutService: LayoutService,
    public el: ElementRef,
    private fileService: FileService,
    public authService: AuthService,
    private organizationService: OrganizationService
  ) {}

  ngOnInit(): void {
    this.getUserProfilePictureMetaData();
    this.getCurrentOrganization();
  }

  activateSearch() {
    this.searchActive = true;
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 100);
  }

  deactivateSearch() {
    this.searchActive = false;
  }
  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  onConfigButtonClick() {
    this.layoutService.showConfigSidebar();
  }

  onSidebarButtonClick() {
    this.layoutService.showSidebar();
  }

  getUserProfilePictureMetaData(): void {
    this.subscriptions.add(
      this.fileService.getProfilePictureMetaData().subscribe({
        next: (res) => {
          if (res) {
            if (res?.result?.fileId) {
              this.getProfileImage(res.result.fileId);
            }
          }
        }
      })
    );
  }

  getProfileImage(fileId: string): void {
    this.subscriptions.add(
      this.fileService.downloadImageFile(fileId).subscribe({
        next: (res) => {
          this.createImageFromBlob(res);
        }
      })
    );
  }

  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.profilePicture = reader.result;
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  logout(): void {
    this.authService.logout();
  }

  getCurrentOrganization(): void {
    this.subscriptions.add(
      this.organizationService.getCurrentOrganization().subscribe({
        next: (res) => {
          this.currentOrganizationName = res.result.organization.name;
          this.isPremiumOrg = res.result.organization.isActiveLicense;
        }
      })
    );
  }
}
